import { API } from '../../Config'
import { API_GET } from '../../Config'

export const GetProduct = () => {
  return (
    API_GET(API.getProductUrl)
  )
}


